module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forms-and-filters"
  }, [_c('div', {
    staticClass: "panel-group accordion",
    attrs: {
      "id": "accordion1"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.reportForms), function(form) {
    return _c('section', [_vm._v(_vm._s(form))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-group accordion",
    attrs: {
      "id": "accordion2"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse_2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.noFilters) ? [_vm._v("No filters applied")] : _vm._e(), _vm._v(" "), _vm._l((_vm.reportFilters), function(formFilters, formName) {
    return [(Object.keys(formFilters).length !== 0) ? [_c('strong', [_vm._v(_vm._s(formName))]), _vm._v(_vm._s(formFilters.hasOwnProperty('isNull') ? (formFilters.isNull ? ' is null' : ' is not null') : '') + "\n            ")] : _vm._e(), _vm._v(" "), _c('ul', _vm._l((formFilters.fieldsFilters), function(filters, fieldName) {
      return (filters.length) ? _c('li', [_vm._v(_vm._s(fieldName) + "\n                "), _c('ul', _vm._l((filters), function(filter) {
        return _c('li', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(filter)
          }
        })])
      }), 0)]) : _vm._e()
    }), 0)]
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion1",
      "href": "#collapse_1"
    }
  }, [_vm._v("Forms "), _c('i', {
    staticClass: "pull-right fa"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#collapse_2"
    }
  }, [_vm._v("Filters "), _c('i', {
    staticClass: "pull-right fa"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-432e5660","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportFormsAndFilters.vue
// module id = 1619
// module chunks = 1